/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Key_Deal_Stage_ChangeInputs */

const cs_audit_key_deal_stage_change = /** @type {(inputs: Audit_Key_Deal_Stage_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna fáze obchodu`)
};

const en_audit_key_deal_stage_change = /** @type {(inputs: Audit_Key_Deal_Stage_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal stage changed`)
};

/**
* | output |
* | --- |
* | "Deal stage changed" |
*
* @param {Audit_Key_Deal_Stage_ChangeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_key_deal_stage_change = /** @type {((inputs?: Audit_Key_Deal_Stage_ChangeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Key_Deal_Stage_ChangeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_key_deal_stage_change(inputs)
	return cs_audit_key_deal_stage_change(inputs)
});